<template>
  <div class="stop">
    <el-button icon="el-icon-refresh" @click="$refresh(getStopsData)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form inline :model="searchForm">
          <el-form-item label="医生姓名">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
              default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择医生" filterable default-first-option>
              <el-option v-for="item in [{ label: '停诊中', value: '0' }, { label: '已取消', value: '1' }]" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getStopsData, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getStopsData, { doctorName: null, status: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button" v-if="deptId">
        <el-button icon="el-icon-plus" type="primary" @click="stopSchedule">新增停诊</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="cancelStopList">批量取消</el-button>
      </div>
      <!-- 信息列表 -->
      <el-table v-loading="loading" :data="stopList" ref="multipleTable" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="doctorName" label="医生姓名" />
        <el-table-column prop="timeRange" label="停诊日期" min-width="200" />
        <el-table-column prop="deptName" label="停诊医馆" v-if="!deptId" />
        <el-table-column prop="statusStr" label="状态" />
        <el-table-column prop="timeName" label="班次" min-width="120" />
        <el-table-column prop="createBy" label="操作员" />
        <el-table-column prop="createTime" label="创建时间" min-width="160" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.status == '1'" icon="el-icon-delete" type="danger"
              @click="cancelStop(scope.row.suspendId)">取消停诊</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增弹框 -->
      <el-dialog class="dialogEdit" title="新增停诊" :visible.sync="dialogVisible" width="500px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="80px" inline>
          <div v-for="(item, index) in editForm.editFormList" :key="item.doctorId" class="stopBox">
            <div class="tagBox">
              <el-tag type="primary">新增停诊 {{ index + 1 }} <i class="el-icon-close" @click="delStop(index)"></i></el-tag>
            </div>
            <el-form-item label="医生姓名" :prop="'editFormList.' + index + '.doctorId'"
              :rules="[{ required: true, message: '医生姓名不能为空！', trigger: 'change' }]">
              <el-select v-model="item.doctorId" placeholder="请选择医生" filterable default-first-option>
                <el-option v-for="kid in doctorOptions" :key="kid.value" :label="kid.label" :value="kid.value">
                  <span class="fl">{{ kid.label }}</span>
                  <span class="select-flex">{{ kid.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="停诊日期" :prop="'editFormList.' + index + '.timeRange'"
              :rules="[{ required: true, message: '停诊日期不能为空！', trigger: 'change' }]">
              <el-date-picker v-model="item.timeRange" value-format="yyyy-MM-dd" type="daterange"
                :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                clearable />
            </el-form-item>
            <!-- <el-form-item label="排班班次">
              <el-select v-model="item.timeIds" placeholder="请选择排班班次" default-first-option multiple filterable clearable>
                <el-option v-for="item in shiftOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item> -->
          </div>
          <el-form-item>
            <el-button icon="el-icon-plus" @click="addStop" type="text" class="fr">添加停诊</el-button>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getStopsData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script lang="js">
import { stopList, stopAdd, stopCancel } from "@/api/stop"; // 引入停诊请求
import { shiftList } from "@/api/shift"; // 引入班次请求
export default {
  name: "Stop",
  data() {
    return {
      loading: true, // 加载中
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      stopList: [], // 停诊列表
      editForm: { editFormList: [] }, // 新增对象
      shiftOptions: [], // 班次选项
      dialogVisible: false, // 模态框状态
      doctorList: [], // 当前页医生列表
      multipleSelection: [], // 被选中行
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      }, // 日期不可选范围
      deptId: this.$session.get("deptId"),
      searchForm: { doctorName: null, status: null }, // 查询表单
      tableHeight: 0, // 表格最大高度
    }
  },
  props: { doctorOptions: Array }, // 接收父组件传递的参数
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getStopsData(); // 获取停诊列表
    this.getShiftsData(); // 获取班次列表
  },
  methods: {
    // 获取停诊列表
    async getStopsData() {
      let { total, rows, code } = await stopList({ pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            this.$session.get("options").forEach(items => {
              if (item.deptId == items.value) item.deptName = items.label;
            });
            if (item.stopTime) item.timeRange = item.startTime + " 至 " + (item.stopTime);
            else item.timeRange = item.startTime;
            item.timeName = '';
            item.timeId = JSON.parse('[' + item.timeId + ']');
            item.timeInfos && item.timeInfos.forEach(obj => {
              item.timeName = `${obj.timeName} ${item.timeName}`
            })
            // item.timeId.forEach(items => {
            //   this.shiftOptions.forEach(itemss => {
            //     if (itemss.value == items) item.timeName = item.timeName + itemss.label + ' ';
            //   });
            // });
            item.status == '0' ? item.statusStr = '停诊中' : item.statusStr = '已取消'
          });
        }
        this.total = total;
        this.stopList = rows;
      }
      this.loading = false;
    },
    // 请求所有班次列表
    async getShiftsData() {
      let { total, rows, code } = await shiftList();
      if (total > 0 && code == 200) {
        rows.forEach(item => { this.shiftOptions.push({ label: item.timeName, value: item.timeId }) });
      }
    },
    // 新增停诊
    stopSchedule() {
      this.dialogVisible = true;
      this.editForm.editFormList = [{ doctorId: null, timeIds: [], timeRange: null }];
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.editForm.editFormList));
          params.forEach(item => {
            let timeIds = JSON.stringify(item.timeIds);
            timeIds = timeIds.substring(1, timeIds.length - 1);
            item.timeId = timeIds;
            item.startTime = item.timeRange[0];
            item.stopTime = item.timeRange[1];
            // if (item.startTime == item.stopTime) item.stopTime = null;
            item.deptId = this.deptId;
            this.doctorOptions.forEach(items => {
              if (item.doctorId == items.value) item.doctorName = items.label;
            })
          });
          stopAdd(params).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增停诊成功！");
            this.dialogVisible = false;
            this.$refresh(this.getStopsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 添加停诊
    addStop() {
      this.editForm.editFormList.push({ doctorId: null, timeIds: [], timeRange: null });
    },
    // 删除停诊
    delStop(i) {
      let list = this.editForm.editFormList
      if (list.length == 1) this.$message('最后一项不能删除！');
      else list.forEach((item, index) => {
        if (index === i) list.splice(index, 1)
      })
    },
    // 取消停诊
    cancelStop(suspendId) {
      this.$confirm('确认取消该停诊？').then(_ => { this.remove(suspendId) }).catch(_ => { });
    },
    async remove(id) {
      let { code } = await stopCancel(id);
      if (code == 200) this.$message.success("取消停诊成功！");
      this.$refresh(this.getStopsData);
    },
    // 批量取消停诊
    cancelStopList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何停诊项！");
      else {
        selected.forEach(item => { selectedId.push(item.suspendId) });
        this.$confirm('确认取消该停诊？').then(_ => { this.remove(selectedId) }).catch(_ => { });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.stop {
  box-sizing: border-box;
  padding: 20px;
}

.wrap {
  .dialogEdit {
    &>div {
      margin-bottom: 20px;
    }

    div.stopBox {
      border: 1px dashed #ccc;
      padding: 5px;
      margin-bottom: 5px;

      .tagBox {
        margin-bottom: 15px;

        .el-icon-close {
          margin-top: 2px;
        }
      }

      /deep/.el-input {
        width: 350px !important;
      }
    }
  }

}</style>